import React from 'react';
import PropTypes from 'prop-types';

import * as styles from './NotFound.module.scss';

const propTypes = {
  /**
   * Heading content
   */
  heading: PropTypes.string,

  /**
   * Description content
   */
  description: PropTypes.string,

  /**
   * Description Bottom content
   */
  descriptionBottom: PropTypes.string,

  /**
   * Button as an object of - href, label
   */
  button: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string
  })
};

const notFound = ({
  heading,
  description,
  descriptionBottom,
  button
}) => {
  if (!heading && !description && !descriptionBottom && !button) {
    return false;
  }

  return (
    <section className={styles.root}>
      <div className={styles.rootTextWrapper}>
        {heading && <div className={styles.rootHeading}>{heading}</div>}
        {description && <p className={styles.rootDescription}>{description}</p>}
        {descriptionBottom && <p className={styles.rootDescriptionBottom}  dangerouslySetInnerHTML={{ __html: descriptionBottom }}/>}
        {(button?.label && button?.href) &&
          <a href={button.href} className={styles.rootButton}>{button.label}</a>}
      </div>
    </section>
  );
};

notFound.propTypes = propTypes;

export default notFound;
